// Complete data extracted from ElemecH Engineering Company Profile PDF

export const companyInfo = {
  name: "ELEMECH ENGINEERING",
  tagline: "Driving Excellence and Reliability",
  foundedYear: 1988,
  description: "Our story began in 1988 with the goal of enhancing Coal Handling Plant (CHP) operations in Thermal Power Stations. Starting with Wagon Tippler maintenance, we've evolved into a prominent name, offering complete CHP services across the country.",
  mission: "To deliver world-class engineering solutions that ensure operational excellence, reliability, and sustainable growth for our clients in the power and industrial sectors.",
  vision: "To be the most trusted partner in industrial engineering, recognized for innovation, quality, and commitment to excellence.",
  website: "elemechengineering.com",
  email: "services@elemechengineering.com"
};

export const chairman = {
  name: "Mr. Raju B. Tandale",
  title: "Chairman & Managing Director",
  phones: ["9130591300"],
  quote: `"The credit belongs to the man who is actually in the arena; whose face is marred with dust and sweat; who strives valiantly, who errs and may fall again and again, because there is no effort without error or shortcoming."`,
  quoteAuthor: "Theodore Roosevelt",
  message: "Our Chairman is a living testimony to these words. With a career that spans more than three decades, Mr. Raju Tandale has dedicated his life to the material handling industry in Thermal Power Plants across Maharashtra and Gujarat. As a Site In-Charge for Elecon Engineering on projects around India, he developed unparalleled expertise in coal handling plant. Today, as the founder and chairman of his own successful enterprise, his journey exemplifies the courage and determination of a true pioneer.",
  experience: "35+ years of industry experience"
};

export const headOfOperations = {
  name: "Mr. Akash R. Tandale",
  title: "Head of Operations & Business",
  phones: ["9766110312"]
};

export const companyHistory = [
  { year: 1988, milestone: "Company established with focus on CHP operations in Thermal Power Stations" },
  { year: 1988, milestone: "Started with Wagon Tippler maintenance services" },
  { year: 1997, milestone: "Awarded Wagon Tippler maintenance contract at another Thermal Power Station (continues to this day)" },
  { year: 2002, milestone: "Established Hardika Enterprises as sister concern for industrial heavy goods and machinery" },
  { year: 2008, milestone: "Expanded to comprehensive Stacker Reclaimer maintenance services (20+ years of expertise)" },
  { year: 2010, milestone: "Started providing complete CHP maintenance solutions" },
  { year: 2020, milestone: "Enlisted with major National Power Corporation units including NTPC and NSPCL" },
  { year: 2024, milestone: "Awarded comprehensive CHP maintenance contract under NSPCL at Rourkela Steel Plant, Odisha" }
];

export const services = [
  {
    id: 1,
    title: "Stacker Reclaimer Operation & Maintenance",
    shortDesc: "Expert maintenance services for stacker reclaimers with over 20 years of proven expertise.",
    fullDesc: "The Stacker Reclaimer, the second most essential auxiliary in the Coal Handling Plant (CHP), plays a vital role in managing coal supply - stacking excess coal and reclaiming it during shortages. For over 20 years, we have been responsible for maintaining the Stacker Reclaimer in Thermal Power Stations. Our expertise and swift response to issues have enabled continuous, uninterrupted operation. Throughout these two decades, we've encountered and efficiently resolved a wide range of maintenance challenges. Our extensive experience has strengthened our capability to ensure seamless performance, supporting TPS's operational resilience.",
    icon: "crane",
    image: "/images/stacker_reclaimer_service.jpeg",
    features: ["20+ Years Experience", "Swift Response to Issues", "Continuous Operation", "Coal Supply Management", "Operational Resilience"]
  },
  {
    id: 2,
    title: "Wagon Tippler Operation & Maintenance",
    shortDesc: "Complete O&M services for wagon tippler systems ensuring 24x7 operation and maximum uptime.",
    fullDesc: "Since its inception, our company was entrusted with the critical task of Wagon Tippler Maintenance in Thermal Power Station in Maharashtra. As the core auxiliary of the Coal Handling Plant (CHP), the Wagon Tippler's 24x7 operation is essential. Through consistent maintenance, we have ensured seamless, uninterrupted performance of this vital component. Following this success, we were awarded a similar contract at another Thermal Power Station in 1997, which continues to this day. Our dedicated efforts have not only minimized breakdowns but have also significantly reduced demurrage costs for Thermal Power Plants in their dealings with Railways, reflecting our commitment to efficiency and reliability.",
    icon: "train",
    image: "/images/wagon_tippler_new.png",
    features: ["24x7 Operation Support", "Preventive Maintenance", "Breakdown Minimization", "Demurrage Cost Reduction", "Railway Coordination"]
  },
  {
    id: 3,
    title: "Conveyor System Maintenance & Housekeeping",
    shortDesc: "Manual and mechanized housekeeping solutions for conveyor belts with 15+ years experience.",
    fullDesc: "For over 15 years, our company has delivered manual as well as mechanized housekeeping solutions for various conveyor belts within the Coal Handling Plant (CHP) at Thermal Power Stations across the country. We have consistently provided top-notch 24x7 housekeeping with optimized manpower, ensuring effective maintenance and minimizing wear and tear on CHP auxiliaries. Before initiating any conveyor housekeeping task, we conduct a comprehensive analysis of the conveyor system, enabling us to implement effective, targeted cleaning solutions. This approach not only enhances cleanliness but also supports the longevity and efficiency of CHP operations.",
    icon: "conveyor",
    image: "/images/conveyor_system_maintenance.jpg",
    features: ["15+ Years Experience", "Manual & Mechanized Solutions", "24x7 Housekeeping", "Comprehensive Analysis", "Longevity Enhancement"]
  },
  {
    id: 4,
    title: "CHP Structural Restoration & Modification",
    shortDesc: "Assessment, analysis, and modification solutions for critical CHP structures.",
    fullDesc: "Since our establishment in 1988, we have undertaken numerous contracts related to CHP auxiliaries, encompassing both housekeeping and maintenance. Over these years, we have consistently ensured the efficient maintenance and smooth functioning of these systems. With over two decades of specialized experience, we have expanded our capabilities to include the assessment, analysis, and monitoring of CHP auxiliaries. Our objective is to provide design, modification and rectification solutions for critical CHP structures such as the Wagon Tippler, Stacker Reclaimer, Conveyor System and Tripper Trolley. We have successfully executed modification and rectification projects for these key components, reinforcing the reliability and efficiency of CHP operations.",
    icon: "building",
    image: "/images/chp_structural_restoration.jpeg",
    features: ["Design Solutions", "Modification & Rectification", "Structural Assessment", "Monitoring Services", "Two Decades Experience"]
  },
  {
    id: 5,
    title: "Complete CHP Maintenance Work",
    shortDesc: "Turnkey maintenance solutions enlisted with NTPC and NSPCL nationwide.",
    fullDesc: "With decades of experience in the sector, we are now proudly enlisted with major National Power Corporation units including NTPC and NSPCL. Our team actively participates in online e-tenders for coal-based thermal power plants across the country. Among our notable achievements is the award of a comprehensive CHP maintenance contract under NSPCL (NTPC-SAIL Power Corporation Ltd) at Rourkela Steel Plant in Odisha. Our commitment to quality and efficiency has been highly regarded at NSPCL units in Rourkela and Bhilai, where we have deployed experienced personnel dedicated to monitoring and ensuring optimal performance.",
    icon: "factory",
    image: "/images/complete_chp_maintenance.jpg",
    features: ["NTPC & NSPCL Enlisted", "Nationwide Coverage", "E-Tender Participation", "Comprehensive Contracts", "Quality Commitment"]
  },
  {
    id: 6,
    title: "Wagon Tippler Side Beam Work",
    shortDesc: "Specialized side beam repair and rectification for structural integrity.",
    fullDesc: "Wagon Tippler Side beams bear significant load and stress during the unloading process. Regular inspection and maintenance are vital to prevent structural failure, ensuring the system remains safe and stable during operation. With a strong specialization in Wagon Tippler and Stacker Reclaimer handling, we have successfully completed side beam repair and rectification projects for both MSPGCL and NTPC. Our extensive expertise in these critical areas has enabled us to execute these tasks with precision and efficiency, ensuring reliable performance and structural integrity for our clients.",
    icon: "beam",
    image: "/images/wagon_tippler_side_beam.jpeg",
    features: ["Load & Stress Management", "Structural Inspection", "MSPGCL & NTPC Projects", "Precision Execution", "Safety Assurance"]
  },
  {
    id: 7,
    title: "Stacker Reclaimer Drive Bogie",
    shortDesc: "Manufacturing, installation, and maintenance of drive bogie systems.",
    fullDesc: "The Stacker Reclaimer Drive Bogie is a critical component of stacker reclaimers, responsible for enabling the movement of the entire machine along the stockpile area. It distributes the machine's weight across multiple wheels, reducing stress on each individual wheel and preventing track damage. We have completed the manufacture of Stacker Reclaimer drive bogie at our workshop and successfully installed the same at TPS. This project underscores our commitment to maintaining high operational standards and ensuring the reliability of critical CHP equipment. Our team's expertise enabled us to carry out the work efficiently, contributing to the uninterrupted functionality of the Stacker Reclaimer system.",
    icon: "wheel",
    image: "/images/stacker_reclaimer_drive_bogie.jpeg",
    features: ["In-house Manufacturing", "Installation Services", "Weight Distribution", "Track Damage Prevention", "Workshop Capabilities"]
  },
  {
    id: 8,
    title: "Wagon Tippler Support Wheel",
    shortDesc: "Repair and refurbishment of support wheels for smooth operation.",
    fullDesc: "Wagon Tippler Support wheel allows for smooth movement and tipping actions, enhancing the overall efficiency of the unloading process. This smooth operation is vital for maintaining productivity in coal and bulk material handling. As part of our completed contract, we have successfully completed the repair and refurbishment of the Wagon Tippler support wheel. This work highlights our commitment to maintaining and enhancing the durability of key CHP components, ensuring continued efficiency and reliability in operations.",
    icon: "cog",
    image: "",
    features: ["Smooth Movement", "Tipping Efficiency", "Repair & Refurbishment", "Durability Enhancement", "Productivity Maintenance"]
  },
  {
    id: 9,
    title: "CHP Air Ventilation System",
    shortDesc: "Design, installation, and commissioning of industrial ventilation systems.",
    fullDesc: "One of the primary functions of an air ventilation system is to manage dust generated during the movement of bulk materials. This is essential for maintaining a clean work environment and reducing health risks associated with airborne dust particles. We have successfully designed, installed and commissioned Air Ventilation system for an underground Conveyor in Thermal Power Station. This project not only enhances the working conditions within the tunnel but also ensures optimal performance and safety for the conveyor system, demonstrating our expertise in delivering comprehensive solutions for complex environments.",
    icon: "wind",
    image: "/images/chp_air_ventilation.jpg",
    features: ["Dust Management", "System Design", "Installation & Commissioning", "Underground Solutions", "Health & Safety Compliance"]
  },
  {
    id: 10,
    title: "Apron Feeder Maintenance",
    shortDesc: "Shutdown maintenance and servicing for apron feeder systems.",
    fullDesc: "Throughout our years of service to the Coal Handling Plant (CHP), we have also successfully executed servicing work for the Apron Feeder during shutdown maintenance at NSPCL & MSPGCL. This project underscores our commitment to maintaining the operational efficiency of critical equipment, ensuring that all systems are thoroughly inspected and serviced to minimize downtime and enhance performance.",
    icon: "layers",
    image: "/images/apron_feeder_maintenance.jpg",
    features: ["Shutdown Maintenance", "NSPCL & MSPGCL Experience", "Thorough Inspection", "Downtime Minimization", "Performance Enhancement"]
  },
  {
    id: 11,
    title: "Main Plant Housekeeping",
    shortDesc: "Comprehensive housekeeping for BTG, boiler washing, and water treatment plants.",
    fullDesc: "In addition to our housekeeping services for conveyor systems in the Coal Handling Plant (CHP), we have been awarded contracts for various other essential services including housekeeping for the Boiler, Turbine, and Generator (BTG), Boiler washing, Water treatment plant maintenance, and other manpower-related works. These contracts reflect our diverse capabilities and commitment to maintaining high standards across multiple operational areas, ensuring the efficiency and reliability of all critical systems within the thermal power plant.",
    icon: "sparkles",
    image: "/images/main_plant_housekeeping.webp",
    features: ["BTG Housekeeping", "Boiler Washing", "Water Treatment Maintenance", "Manpower Solutions", "Multi-Area Expertise"]
  },
  {
    id: 12,
    title: "Hydraulic System Maintenance",
    shortDesc: "Servicing, modifications, and replacements for hydraulic systems.",
    fullDesc: "One of our most recognized and praised achievements is the servicing and maintenance of the hydraulic systems for both the Wagon Tippler and Stacker Reclaimer. We have efficiently managed these hydraulic systems, implementing various modifications that have significantly enhanced their operational efficiency. In addition to hydraulic system services, we have also conducted hydraulic cylinder replacements and servicing for both the Stacker Reclaimer and Wagon Tippler. Our capabilities extend to gearbox replacements for these critical components, ensuring their reliability and optimal performance in the Coal Handling Plant. Our proactive approach to maintenance has consistently contributed to improved efficiency and reduced downtime.",
    icon: "droplets",
    image: "/images/hydraulic_system_maintenance.jpg",
    features: ["System Servicing", "Efficiency Modifications", "Cylinder Replacements", "Gearbox Replacements", "Proactive Maintenance"]
  },
  {
    id: 13,
    title: "Stacker Reclaimer Long Travel Restrengthening",
    shortDesc: "Rail track foundation repair and restrengthening for structural stability.",
    fullDesc: "Stacker Reclaimer Rail Tracks distribute the weight of the stacker reclaimer evenly, minimizing stress on individual components and preventing track deformation over time & avoid damage to Slew Bearing. We have completed the repair and restrengthening of the Stacker Reclaimer's long travel rail foundation. This project was critical in ensuring the stability and reliability of the Stacker Reclaimer system, enhancing its overall performance. Our meticulous approach to this work underscores our commitment to maintaining the structural integrity of essential equipment within the Coal Handling Plant.",
    icon: "rail",
    image: "/images/stacker_reclaimer_long_travel.jpeg",
    features: ["Weight Distribution", "Track Deformation Prevention", "Rail Foundation Repair", "Slew Bearing Protection", "Structural Integrity"]
  },
  {
    id: 14,
    title: "Flue Gas Desulfurization (FGD) Maintenance",
    shortDesc: "Biennial electrical maintenance for FGD systems ensuring environmental compliance.",
    fullDesc: "We have successfully executed a biennial electrical maintenance contract for the Flue Gas Desulfurization (FGD) system at NTPC Unchahar. This contract is vital for maintaining the operational efficiency and reliability of the FGD system, which plays a crucial role in reducing sulfur dioxide emissions and ensuring compliance with environmental regulations. Our approach to this contract involves comprehensive electrical maintenance practices, including regular inspections, troubleshooting, and prompt repairs. By implementing a systematic maintenance schedule, we ensure that all electrical components of the FGD system function optimally, minimizing the risk of unexpected downtime and enhancing overall system performance.",
    icon: "fan",
    image: "/images/fgd_maintenance.jpeg",
    features: ["NTPC Unchahar Contract", "Biennial Maintenance", "Electrical Systems", "Environmental Compliance", "SO2 Emission Reduction"]
  }
];

export const projects = [
  {
    id: 1,
    title: "Wagon Tippler Maintenance",
    description: "Critical Wagon Tippler maintenance since company inception, ensuring 24x7 operation with minimized breakdowns and reduced demurrage costs.",
    client: "Multiple TPS",
    year: "35+ Years",
    type: "Operation & Maintenance"
  },
  {
    id: 3,
    title: "Stacker Reclaimer Maintenance",
    description: "Over 20 years of continuous maintenance services for Stacker Reclaimers in Thermal Power Stations with swift response and efficient issue resolution.",
    client: "Multiple TPS",
    year: "20+ Years",
    type: "Operation & Maintenance"
  },
  {
    id: 4,
    title: "Conveyor System Housekeeping",
    description: "15+ years of manual and mechanized housekeeping solutions for conveyor belts across multiple Coal Handling Plants.",
    client: "Multiple TPS",
    year: "15+ Years",
    type: "Housekeeping & Maintenance"
  },
  {
    id: 5,
    title: "CHP Structural Modification Projects",
    description: "Successful modification and rectification projects for Wagon Tippler, Stacker Reclaimer, Conveyor System, and Tripper Trolley structures.",
    client: "Multiple TPS",
    year: "Completed",
    type: "Structural Restoration"
  },
  {
    id: 6,
    title: "CHP Maintenance",
    description: "Comprehensive Coal Handling Plant maintenance contract delivering end-to-end solutions for all CHP auxiliaries and systems.",
    client: "Multiple TPS",
    year: "Completed",
    type: "Complete CHP Maintenance"
  },
  {
    id: 7,
    title: "Side Beam Repair",
    description: "Successfully completed side beam repair and rectification projects ensuring structural integrity and safety.",
    client: "Multiple TPS",
    year: "Completed",
    type: "Structural Work"
  },
  {
    id: 8,
    title: "Drive Bogie Manufacturing & Installation",
    description: "Manufactured Stacker Reclaimer drive bogie at our workshop and successfully installed at TPS.",
    client: "Multiple TPS",
    year: "Completed",
    type: "Manufacturing & Installation"
  },
  {
    id: 9,
    title: "Wagon Tippler Support Wheel Refurbishment",
    description: "Repair and refurbishment of Wagon Tippler support wheel enhancing durability and operational efficiency.",
    client: "Multiple TPS",
    year: "Completed",
    type: "Repair & Refurbishment"
  },
  {
    id: 10,
    title: "Underground Conveyor Ventilation System",
    description: "Designed, installed, and commissioned Air Ventilation system for underground conveyor in Thermal Power Station.",
    client: "Multiple TPS",
    year: "Completed",
    type: "Design & Installation"
  },
  {
    id: 11,
    title: "Apron Feeder Servicing",
    description: "Executed servicing work during shutdown maintenance ensuring operational efficiency.",
    client: "Multiple TPS",
    year: "Completed",
    type: "Shutdown Maintenance"
  },
  {
    id: 12,
    title: "BTG & Main Plant Housekeeping",
    description: "Awarded contracts for Boiler, Turbine, Generator housekeeping, boiler washing, and water treatment plant maintenance.",
    client: "Multiple TPS",
    year: "Completed",
    type: "Housekeeping Services"
  },
  {
    id: 13,
    title: "Hydraulic System Modifications",
    description: "Servicing and maintenance of hydraulic systems with efficiency-enhancing modifications, cylinder replacements, and gearbox replacements.",
    client: "Multiple TPS",
    year: "Completed",
    type: "Hydraulic Maintenance"
  },
  {
    id: 14,
    title: "Stacker Reclaimer Rail Foundation Repair",
    description: "Successfully executed repair and restrengthening of Stacker Reclaimer's long travel rail foundation.",
    client: "Multiple TPS",
    year: "Completed",
    type: "Structural Repair"
  },
  {
    id: 15,
    title: "FGD Electrical Maintenance",
    description: "Biennial electrical maintenance contract for Flue Gas Desulfurization system ensuring environmental compliance.",
    client: "Multiple TPS",
    year: "Biennial",
    type: "FGD Maintenance"
  }
];

export const clients = [
  { 
    name: "MAHAGENCO", 
    fullName: "Maharashtra State Power Generation Company Limited",
    logo: "/images/mahagenco_logo.png",
    type: "client"
  },
  { 
    name: "GSECL", 
    fullName: "Gujarat State Electricity Corporation Limited",
    logo: "/images/gsecl_logo.jpeg",
    type: "client"
  },
  { 
    name: "NTPC", 
    fullName: "National Thermal Power Corporation",
    logo: "/images/ntpc_logo.png",
    type: "client"
  },
  { 
    name: "NSPCL", 
    fullName: "NTPC-SAIL Power Company Limited",
    logo: "/images/nspcl_logo.jpeg",
    type: "client"
  }
];

export const collaborations = [
  {
    name: "Rulmeca",
    country: "Italy",
    description: "Global leader in rollers and motorized pulleys for bulk handling",
    logo: "/images/rulmeca_logo.png",
    type: "collaboration"
  },
  {
    name: "Tru-Trac",
    fullName: "Tru-Trac Rollers Pty Ltd",
    country: "South Africa",
    description: "Specialists in conveyor belt tracking solutions",
    logo: "/images/trutrac_logo.png",
    type: "collaboration"
  },
  {
    name: "Havells",
    fullName: "Havells India Ltd",
    country: "India",
    description: "Leading electrical equipment manufacturer",
    logo: "/images/havells_logo.png",
    type: "collaboration"
  },
  {
    name: "Flexco",
    fullName: "Flexco",
    country: "USA",
    description: "Global leader in belt conveyor products and solutions",
    logo: "/images/flexco_logo.png",
    type: "collaboration"
  }
];

export const sisterConcern = {
  name: "Hardika Enterprises",
  established: 2002,
  description: "Our sister concern dealing in industrial heavy goods and machinery, providing integrated supply chain solutions.",
  services: ["Industrial Heavy Goods", "Machinery Supply", "Authorized Dealer for Major Brands"]
};

export const statistics = [
  { value: "SINCE 1988", label: "Year Established" },
  { value: "35+", label: "Years of Excellence" },
  { value: "500+", label: "Total Workforce" },
  { value: "PAN INDIA", label: "Service Coverage" },
  { value: "25+", label: "Specialized Professionals" },
  { value: "20+", label: "Years in Stacker Reclaimer" },
  { value: "15+", label: "Years in Conveyor Systems" }
];

export const contactInfo = {
  address: {
    line1: "Shop No: 24, Rajat Heights",
    line2: "Koradi Road, Near Wox Cooler",
    line3: "Koradi Octroi Post",
    city: "Nagpur",
    state: "Maharashtra",
    country: "India",
    pincode: "440030"
  },
  contacts: [
    {
      name: "Mr. Raju B. Tandale",
      designation: "Chairman & Managing Director",
      phones: ["+91 9130591300"]
    },
    {
      name: "Mr. Akash R. Tandale",
      designation: "Head of Operations & Business",
      phones: ["+91 9766110312"]
    }
  ],
  email: "services@elemechengineering.com",
  website: "elemechengineering.com",
  mobile: "+91 9766110312"
};

export const capabilities = [
  "Coal Handling Plants (CHP)",
  "Thermal Power Plant Equipment",
  "Wagon Tipplers",
  "Stacker Reclaimers",
  "Conveyor Systems",
  "Structural Restoration & Modification",
  "Hydraulic Systems",
  "FGD Systems",
  "Drive Bogie Manufacturing",
  "Support Wheel Repair",
  "Air Ventilation Systems",
  "Apron Feeders",
  "BTG Housekeeping",
  "Water Treatment Plants"
];

export const industriesServed = [
  "Thermal Power Plants",
  "Coal Handling Plants",
  "Steel Plants",
  "Bulk Material Handling",
  "Power Generation Sector"
];

export const workforce = {
  koradiTPS: "Over 300 workers",
  nspcl: "More than 200 workers at Rourkela and Bhilai",
  specializedTeam: "Around 25 professionals for specialized maintenance",
  description: "Our dedicated workforce ensures optimal performance and continuous monitoring across all our project sites."
};
